module.exports = __webpack_public_path__ + "static/img/passion-landing.11d7831.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/passion-landing.png
// module id = 134
// module chunks = 0